module.exports = __webpack_public_path__ + "static/img/vip-img3.2764c92.png";


//////////////////
// WEBPACK FOOTER
// ./static/moblieHome/vip-img3.png
// module id = kC/U
// module chunks = 1